import { UPLOAD_PATH } from '../../shared/limits';
import { runEngine } from './engine';
import {
  MeasurementError,
  toMeasurementError,
  type MeasurementProvider,
  type RawMeasurementResult,
  type TestOptions,
  type TestStage,
} from './types';
import { measureUpload } from './upload';

/** Measures against the Worker that served this page (same origin, HTTP/2-only NetHealthLab hostname in production). */
export class CloudflareWorkersProvider implements MeasurementProvider {
  readonly name = 'cloudflare-workers';

  async startTest(options: TestOptions = {}): Promise<RawMeasurementResult> {
    const { onStage, signal } = options;
    const t0 = performance.now();
    const startedAt = new Date().toISOString();
    let stage: TestStage = 'connecting';
    const enter = (next: TestStage) => {
      stage = next;
      onStage?.(next);
    };

    try {
      enter('connecting');
      const engine = await runEngine({ onStage: enter, signal });
      enter('upload');
      const upload = await measureUpload(`${UPLOAD_PATH}?m=a`, { signal });
      if (upload.mbps === null) {
        throw new MeasurementError('network', upload.errors[0] ?? 'Upload did not complete.', 'upload', { engine, upload });
      }
      return {
        provider: this.name,
        endpoint: location.origin,
        startedAt,
        durationMs: performance.now() - t0,
        engine,
        upload,
      };
    } catch (error) {
      const failure = toMeasurementError(error, stage);
      throw failure.stage ? failure : new MeasurementError(failure.code, failure.message, stage, failure.details);
    }
  }
}
